// extracted by mini-css-extract-plugin
export default {"headerAbsolute":"Header_headerAbsolute__iWZZ6","header":"Header_header__Agk3M","header_navLink":"Header_header_navLink__r-mpl","active":"Header_active__zRxDR"};